import Nfse from "@/domain/notas/nfse/Nfse.js";
import Table from "./Table";
export default class TableNfse extends Table {
  constructor() {
    super();
  }

  getHeaders(nfseTomados=false) {
      var headers = [
        { text: "Ações", value: "acoes", show: true, pesq: false, enable: false },
        { text: "Data de Emissão", value: "dtEmissaoNfe", show: true, width: "500px", pesq: false, enable: true },
        { text: "Número", value: "numeroNfe", show: true, pesq: true, enable: true },
        { text: "Valor do Crédito", value: "vlrCredito", show: true, pesq: false, enable: true },
        { text: "Valor do Serviço", value: "vlrServico", show: true, pesq: false, enable: true },
        { text: "ISS Retido", value: "ISSRetido", show: true, pesq: false, enable: true },
        { text: "Código do Serviço", value: "codServico", show: true, pesq: false, enable: true },
        { text: "Código de Verificação", value: "codVerificacao", show: true, pesq: false, enable: true },
        { text: "Aliquota do Serviço (%)", value: "aliqServico", show: true, pesq: false, enable: true },
        { text: "Status", value: "statusNFe", show: true, pesq: false, enable: true },
        { text: "Origem", value: "origem", show: true, pesq: false, enable: true },
        { text: "Opção do Simples", value: "opcaoSimples", show: true, pesq: false, enable: true },
        { text: "Número do Lote", value: "numLote", show: true, pesq: true, enable: true },
        { text: "Número RPS", value: "numRPS", show: true, pesq: false, enable: true },
        { text: "Série RPS", value: "serieRPS", show: true, pesq: false, enable: true },
        { text: "Tipo RPS", value: "tipoRPS", show: true, pesq: false, enable: true },
        { text: "Data Emissão RPS", value: "dtEmissaoRPS", show: true, pesq: false, enable: true },
        { text: "CNPJ/CPF Tomador", value: "cnpjCpf", show: true, pesq: true, enable: true },
        { text: "Razão Social Tomador", value: "razao", show: true, pesq: true, enable: true },
        {text: "Inscrição Tomador",value: "insc",show: true,pesq: true,enable: true},
        {text: "Tributação",value: "tribNfe",show: true,pesq: false,enable: true},
        {text: "Valor do ISS",value: "vlrISS",show: true,pesq: false,enable: true},
        {text: "Discriminação",value: "discriminacao",show: true,pesq: false,enable: true},
        { text: "_id", value: "_id", show: false, pesq: false, enable: false },
        {text: "pathPdf",value: "pathPdf",show: false,pesq: false,enable: false},
        {text: "pathPdfMotor",value: "pathPdfMotor",show: false,pesq: false,enable: true},
        {text: "gzipPath",value: "gzipPath",show: false,pesq: false,enable: false},
        {text: "id_empresa",value: "empresa",show: false,pesq: false,enable: false},
        {text: "Pis",value: "PIS",show: true,pesq: true,enable: true},
        {text: "COFINS",value: "COFINS",show: true,pesq: false,enable: true},
        {text: "CSLL",value: "CSLL",show: true,pesq: false,enable: true},
        {text: "INSS",value: "INSS",show: true,pesq: false,enable: true},
        {text: "IR",value: "IR",show: true,pesq: false,enable: true},
        {text: "Código Lei 116",value: "codLei",show: true,pesq: false,enable: true},  
        {text: "Descrição Lei 116",value: "lei",show: true,pesq: false,enable: false},
        {text: "Data ERP", value: "data_erp", show: true, pesq: false, enable: true},
        { text: "Nome Município", value: "nome_municipio", show: true, pesq: true, enable: true },
        { text: "Simples Nacional", value: "simples_nacional", show: true, pesq: true, enable: true },
        {text: "NFTS", value: "status_escrituracao", show: true, pesq: false, enable: true},
        { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false,enable:true},
        { text: "Id Fluig", value: "id_fluig", show: true, pesq: true,enable:true},
        { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false,enable:true},
        { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false,enable:true},
        { text: "log_escrituracao", value: "log_escrituracao", show: false, pesq: false,enable: true},
        { text: "Número do pedido", value: "numeroPedido", show: true, pesq: true,enable: true},  
        {
          text: "Pós Fechamento",
          value: "posFechamento",
          show: true,
          pesq: true,
          enable: true,
        },      
        { text: "Valor Recebido", value: "valorTotalRecebido", show: true, pesq: true,enable: true},        
        { text: "Provedor", value: "provedor", show: true, pesq: true,enable: true},
        { text: "Documento", value: "documento", show: true, pesq: true,enable: true},
        { text: "Nome Arquvo", value: "nomeArquivo", show: true, pesq: true,enable: true}
        
      ];

      if(nfseTomados) {
        headers.push(
          {text: "Status da Emissão",value: "statusEmissao",show: true,pesq: true,enable: true},
          {text: "Data serviço",value: "dataServico",show: true,pesq: true,enable: true},
          {text: "Emissao Motor",value: "emissaoMotor",show: false,pesq: false,enable: true},
          {text: "Erro Emissao",value: "erroEmissao",show: false,pesq: false,enable: true},
          {text: "log_escrituracao",value: "log_escrituracao",show: false,pesq: false,enable: true},
          {text: "Pdv", value: "pdv", show: true, pesq: false, enable: true},
          {text: "pathPdfMotor",value: "pathPdfMotor",show: false,pesq: false,enable: false},
          {text: "Numero do Pdv", value: "numero_pdv", show: true, pesq: false, enable: true},
          {text: "Data Pdv", value: "data_pdv", show: true, pesq: false, enable: true}
        )
      }
  
      return headers;
  }

  setNota(arrayNotas, notas) {
    let newArray = arrayNotas;
    this.loading = false;
    for (var i = 0; i < notas.length; i++) {
      newArray.push(
        new Nfse(
          notas[i]._id,
          notas[i].empresa,
          notas[i].dtEmissaoNfe,
          notas[i].numeroNfe,
          notas[i].vlrCredito,
          notas[i].vlrServico,
          notas[i].ISSRetido,
          notas[i].codServico,
          notas[i].codVerificacao,
          notas[i].aliqServico,
          notas[i].statusNFe,
          notas[i].origem,
          notas[i].tipo,
          notas[i].opcaoSimples,
          notas[i].numLote,
          notas[i].numRPS,
          notas[i].serieRPS,
          notas[i].tipoRPS,
          notas[i].dtEmissaoRPS,
          notas[i].cnpjCpfTomador,
          notas[i].razaoTomador,
          notas[i].inscTomador,
          notas[i].tribNfe,
          notas[i].ISS,
          notas[i].discriminacao,
          notas[i].pathPdf,
          notas[i].pathPdfMotor,
          notas[i].gzipPath,
          notas[i].customValues,
          notas[i].statusErp,
          notas[i].PIS,
          notas[i].COFINS,
          notas[i].CSLL,
          notas[i].INSS,
          notas[i].IR,
          notas[i].lei? notas[i].lei.codigo : undefined,
          notas[i].lei? notas[i].lei: undefined,
          notas[i].statusEmissao,
          notas[i].razaoTomador,
          notas[i].inscPrestador,
          notas[i].emissaoMotor,
          notas[i].dataServico,
          notas[i].codMun,
          notas[i].cnpjCpfTomador,
          notas[i].cnpjCpfPrestador,
          notas[i].statusDES,
          notas[i].erroDES,
          notas[i].erroEmissao,
          notas[i].data_erp,
          notas[i].status_escrituracao,
          notas[i].log_statusErp,
          notas[i].id_fluig,
          notas[i].log_statusErpDois,
          notas[i].statusErpDois,
          notas[i].log_escrituracao,
          notas[i].pdv,
          notas[i].numero_pdv,
          notas[i].data_pdv,
          notas[i].nome_municipio ? notas[i].nome_municipio: '',
          notas[i].simples_nacional ? notas[i].simples_nacional.descricao: '',
          notas[i].posFechamento,
          notas[i].numeroPedido,
          notas[i].valorTotalRecebido,
          notas[i].provedor,
          notas[i].documento,
          notas[i].tipoTomador
        )
      );
      this.pagination.sortBy = "dtEmissaoNfe";
      this.pagination.descending = true;
    }
    if(arrayNotas.length > 0) {
        arrayNotas = [ ...arrayNotas, ...newArray ];
        return arrayNotas;
    }else {
        return newArray;
    }
}
}



// WEBPACK FOOTER //
// ./src/domain/dataTable/TableNfseEmitida.js